define('widgets/forward',[
	'jquery',
	'lib/jquery-ui/widget',
	'lib/jquery.form-validator'
], function ($) {

	return $.widget('muse.forward', {

		options: {
		},

		_create: function () {

			this.$toggle = this.element.parent().find('.forward-icon');
			this.$message = this.element.find('.message');
			this.$form = this.element.find('form');
			this.enabled =  this.element.hasClass('enabled');

			this._on({
				'click .close': 'onClickClose'
			});

			this._on(this.$toggle, {
				'click': 'onClickToggle'
			});

			this._on(this.$form, {
				'submit': function (e) { e.preventDefault(); return false; }
			});

			this.id = this.$form.attr('id');
			if (!this.id) {
				this.id = 'form_' + this.uuid;
				this.$form.attr('id', this.id);
			}

			$.validate({
				form : '#' + this.id,
				onSuccess: $.proxy(this, 'onSubmit'),
				borderColorOnError : '',
				validateOnBlur: false
			});

			return this._super();

		},

		onClickToggle: function (e) {

			this.toggle();
			e.preventDefault();

		},

		onSubmit: function (e) {

			var data = this.$form.serialize();

			$.post('email/forward', data)
				.done($.proxy(this, 'onSent'))
				.fail($.proxy(this, 'onError'));

			this.$message.text('>sending...');

			this.enabled = false;
			this.element
				.removeClass('enabled')
				.addClass('done');

			return false;

		},

		onSent: function (response) {

			if (response == 'ok') {
				this.$form.find('input[type=text], textarea').val('');
				this.$message.text('>email sent.');
			} else {
				this.onError();
			}

		},

		onError: function () {

			this.$message.text('>error while sending email, please try again later.');

		},

		onClickClose: function (e) {

			this.element.removeClass('enabled').removeClass('done');
			this.enabled = false;

			e.preventDefault();

		},

		toggle: function () {

			this.element.toggleClass('enabled');
			this.enabled = this.element.hasClass('enabled');

			if (this.enabled) {
				this.element.removeClass('done');
				this.element.find('input').first().focus();
			}

		}

	});

});
